import { Navigate, Route, Routes } from "react-router"
import { Layout } from "@/components/Layout"
import { AwardsBanner } from "@/components/AwardsBanner"
import Home from "@/pages/Home"
import Technology from "@/pages/Technology"
import Products from "@/pages/Products"
import Initiative from "@/pages/Initiative"
import Deployments from "@/pages/Deployments"
import Pilot from "@/pages/Pilot"
import StartPilot from "@/pages/StartPilot"
import Development from "@/pages/Development"
import About from "@/pages/About"
import Team from "@/pages/Team"
import Partners from "@/pages/Partners"
import Gallery from "@/pages/Gallery"
import Blog from "@/pages/Blog"
import BlogPost from "@/pages/BlogPost"
import Contact from "@/pages/Contact"
import NotFound from "@/pages/NotFound"

export default function App() {
  return (
    <>
    <AwardsBanner />
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/technology" element={<Technology />} />
        <Route path="/products" element={<Products />} />
        <Route path="/initiative" element={<Initiative />} />
        <Route path="/deployments" element={<Deployments />} />
        <Route path="/pilot" element={<Pilot />} />
        <Route path="/start-pilot" element={<StartPilot />} />
        <Route path="/development" element={<Development />} />
        <Route path="/about" element={<About />} />
        <Route path="/team" element={<Team />} />
        <Route path="/partners" element={<Partners />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/contact" element={<Contact />} />

        {/* Preserve legacy public URLs during migration. */}
        <Route path="/the-smart-drain-technology" element={<Navigate to="/technology" replace />} />
        <Route path="/global-smart-drain-initiative" element={<Navigate to="/initiative" replace />} />
        <Route path="/smart-drain-field-deployment-projects" element={<Navigate to="/deployments" replace />} />
        <Route path="/development-roadmap" element={<Navigate to="/development" replace />} />
        <Route path="/about-us" element={<Navigate to="/about" replace />} />
        <Route path="/meet-the-team" element={<Navigate to="/team" replace />} />
        <Route path="/our-partners" element={<Navigate to="/partners" replace />} />
        <Route path="/contact-us" element={<Navigate to="/contact" replace />} />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </Layout>
    </>
  )
}
